export const debouncedDataLoadWaitMs = 500;
export const CLIENT_ID_ROUTI = 'routi';
export const GRANT_TYPE_AUTH_CODE = 'authorization_code';
export const GRANT_TYPE_REFRESH_TOKEN = 'refresh_token';
export const SCOPE_COOKIE = 'cookie';

export const HTTP_METHODS = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
  PATCH: 'PATCH',
};

export const STATUS = {
  SUCCESS: 'success',
  WARNING: 'warn',
  ERROR: 'error',
};

export const COURIER_ACTIVE_PASSIVE = {
  true: true,
  false: false,
};

export const COURIER_TYPE = {
  STAFF: 'STAFF',
  TRADESMAN: 'TRADESMAN',
};

export const VEHICLE_TYPE = {
  MOTORCYCLE: 'MOTORCYCLE',
  COMMERCIAL_VEHICLE: 'COMMERCIAL_VEHICLE',
  PASSENGER_VEHICLE: 'PASSENGER_VEHICLE',
};

export const LOCATION_TYPE = {
  STORE: 'STORE',
  REGION: 'REGION',
  ZONE: 'ZONE',
};

export const SHAPE_TYPE = {
  POLYGON: 'POLYGON',
  RECTANGLE: 'RECTANGLE',
  CIRCLE: 'CIRCLE',
};

export const COURIER_DOCUMENT_TYPES = {
  TAX_PLATE: 'TAX_PLATE',
  BANK_BOOK: 'BANK_BOOK',
  AUTHORIZED_SIGNATURES: 'AUTHORIZED_SIGNATURES',
  VEHICLE_REGISTRATION: 'VEHICLE_REGISTRATION',
  CRIMINAL_RECORD: 'CRIMINAL_RECORD',
  CAR_INSURANCE: 'CAR_INSURANCE',
  DRIVING_LICENCE: 'DRIVING_LICENCE',
  SOCIAL_INSURANCE: 'SOCIAL_INSURANCE',
};

export const FORBIDDEN_ROLES_FOR_USER_EDIT = [
  'REGIONAL_EXECUTIVE',
  'REGIONAL_MANAGER',
  'BRANCH_MANAGER',
  'REGIONAL_DIRECTOR',
];

export const OPERATIONAL_ROLES = [
  'CENTRAL_OPERATIONS_OFFICER',
  'CENTRAL_OPERATIONS_EXECUTIVE',
  'CENTRAL_OPERATIONS_VIEWER',
  'ROUTI',
  'ECOM_OPERATIONS_SPECIALIST',
  'LOGISTICS_EXECUTIVE',
];

export const STORE_BASED_ROLES = [
  'COLLECTOR',
  'STORE_MANAGER',
  'STORE_SALER',
  'BUDDY_MANAGER_CANDIDATE',
  'STORE_MANAGER_2_0',
  'STORE_MANAGER_CANDIDATE',
  'STORE_MANAGER_SUPPORTER',
  'STORE_MANAGER_SUPPORTER_MINI',
  'STORE_MANAGER_SUPPORTER_CANDIDATE',
  'STORE_SALER_PART_TIME',
  'STORE_SALER_MINI',
  'STORE_SALER_SEASON',
  'STORE_SALER_MANAGER_CANDIDATE',
  'NOT_ECOM_STORE_SALER',
  'NOT_ECOM_BUDDY_MANAGER_CANDIDATE',
  'NOT_ECOM_STORE_MANAGER_2_0',
  'NOT_ECOM_STORE_MANAGER_CANDIDATE',
  'NOT_ECOM_STORE_MANAGER_SUPPORTER',
  'NOT_ECOM_STORE_MANAGER_SUPPORTER_MINI',
  'NOT_ECOM_STORE_MANAGER_SUPPORTER_CANDIDATE',
  'NOT_ECOM_STORE_SALER_PART_TIME',
  'NOT_ECOM_STORE_SALER_MINI',
  'NOT_ECOM_STORE_SALER_SEASON',
  'NOT_ECOM_STORE_SALER_MANAGER_CANDIDATE',
];

export const REGION_BASED_ROLES = [
  'REGIONAL_EXECUTIVE',
  'REGIONAL_MANAGER',
  'REGIONAL_DIRECTOR',
  'BRANCH_MANAGER',
  'BRANCH_MANAGER_SUPPORTER',
  'REGIONAL_MANAGER_SUPPORTER',
  'REGIONAL_EXECUTIVE_SUPPORTER',
  'NOT_ECOM_BRANCH_MANAGER_SUPPORTER',
  'NOT_ECOM_REGIONAL_MANAGER_SUPPORTER',
  'NOT_ECOM_REGIONAL_EXECUTIVE_SUPPORTER',
  'REGIONAL_HR_EXECUTIVE',
];

export const ALL_USER_ROLES = {
  MANAGER: 'MANAGER',
  COLLECTOR: 'COLLECTOR',
  REGIONAL_MANAGER: 'REGIONAL MANAGER',
  STORE_MANAGER: 'STORE MANAGER',
  REGIONAL_EXECUTIVE: 'REGIONAL EXECUTIVE',
  BRANCH_MANAGER: 'BRANCH MANAGER',
  CENTRAL_OPERATIONS_OFFICER: 'CENTRAL OPERATIONS OFFICER',
  CENTRAL_OPERATIONS_EXECUTIVE: 'CENTRAL OPERATIONS EXECUTIVE',
  CENTRAL_OPERATIONS_VIEWER: 'CENTRAL OPERATIONS VIEWER',
  COURIER: 'COURIER',
  REGIONAL_DIRECTOR: 'REGIONAL DIRECTOR',
};

export const ORDER_STATUSES = {
  NEW_ORDER: 'NEW_ORDER',
  COLLECTING: 'COLLECTING',
  SEMI_COLLECTED: 'SEMI_COLLECTED',
  COLLECTED: 'COLLECTED',
  IN_TRANSIT: 'IN_TRANSIT',
  AT_CUSTOMER_ADDRESS: 'AT_CUSTOMER_ADDRESS',
  DELIVERED: 'DELIVERED',
  NOT_DELIVERED: 'NOT_DELIVERED',
  WAITING_FOR_APPROVAL: 'WAITING_FOR_APPROVAL',
  ARRIVED_AT_STORE: 'ARRIVED_AT_STORE',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
  REFUNDED: 'REFUNDED',
  ASSIGNED_TO_COURIER: 'ASSIGNED_TO_COURIER',
  TRANSFERRED: 'TRANSFERRED',
  RETURN_REQUEST_RECEIVED: 'RETURN_REQUEST_RECEIVED',
  COURIER_ON_RETURN_PICKUP_WAY: 'COURIER_ON_RETURN_PICKUP_WAY',
  PICK_UP_AT_CUSTOMER: 'PICK_UP_AT_CUSTOMER',
  RETURN_PICKED_UP: 'RETURN_PICKED_UP',
  RETURN_PICKUP_MISSED: 'RETURN_PICKUP_MISSED',
  RETURN_PICKUP_COMPLETED: 'RETURN_PICKUP_COMPLETED',
  RETURN_PICKUP_REJECTED: 'RETURN_PICKUP_REJECTED',
  RETURNED_TO_STORE: 'RETURNED_TO_STORE',
};

export const ORDER_ERROR_STATUSES = ['CANCELLED', 'NOT_DELIVERED'];

export const FILTER_STATUS_FOR_COURIER_PERFORMANCE_PERCENTAGE = {
  DELIVERED: 'DELIVERED',
  NOT_DELIVERED: 'NOT_DELIVERED',
  WAITING_FOR_APPROVAL: 'WAITING_FOR_APPROVAL',
  ARRIVED_AT_STORE: 'ARRIVED_AT_STORE',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
};

export const ORDER_STATUS_COLORS = {
  NEW_ORDER: '#a4c2f4',
  COLLECTING: '#ffce55',
  SEMI_COLLECTED: '#ffce55',
  COLLECTED: '#ffce55',
  IN_TRANSIT: '#93c47d',
  AT_CUSTOMER_ADDRESS: '#93c47d',
  DELIVERED: '#5BC1A6',
  NOT_DELIVERED: '#8e7cc3',
  WAITING_FOR_APPROVAL: '#8e7cc3',
  ARRIVED_AT_STORE: '#8e7cc3',
  COMPLETED: '#5BC1A6',
  CANCELLED: '#f26e53',
  REFUNDED: '#a12412',
  ASSIGNED_TO_COURIER: '#f2538b',
  RETURN_REQUEST_RECEIVED: '#a4c2f4',
  COURIER_ON_RETURN_PICKUP_WAY: '#93c47d',
  PICK_UP_AT_CUSTOMER: '#93c47d',
  RETURN_PICKED_UP: '#5BC1A6',
  RETURN_PICKUP_MISSED: '#8e7cc3',
  RETURN_PICKUP_COMPLETED: '#5BC1A6',
  RETURN_PICKUP_REJECTED: '#f26e53',
  RETURNED_TO_STORE: '#93c47d',
};

export const COURIER_TYPE_COLORS = {
  [COURIER_TYPE.TRADESMAN]: 'purple',
  [COURIER_TYPE.STAFF]: 'blue',
};

export const ORDER_TYPES = {
  ascend: 'asc',
  descend: 'desc',
};

export const USER_TYPES = {
  COLLECTOR: 'Collector',
  COURIER: 'Courier',
};

export const END_OF_DATE_REPORT_SUMMARY_FIELDS = {
  TOTAL_CASH_FEE: 'totalCashFee',
  TOTAL_CREDIT_CARD_FEE: 'totalCreditCardFee',
  TOTAL_MASTERPASS_FEE: 'totalMasterpassFee',
  TOTAL_WALLET_FEE: 'totalVoucherFee',
  TOTAL_GIFTCARD_FEE: 'totalGiftCardFee',
  TOTAL_OTHER_FEE: 'totalOtherFee',
  TOTAL_FEE: 'totalFee',
};

export const END_OF_DATE_REPORT_PAYMENT_TYPES = {
  MASTERPASS: 'MASTERPASS',
  CASH_ON_DELIVERY: 'CASH_ON_DELIVERY',
  CASH_ON_DELIVERY_BY_CREDIT_CARD: 'CASH_ON_DELIVERY_BY_CREDIT_CARD',
  PAYMENT_BY_VOUCHERS: 'PAYMENT_BY_VOUCHERS',
  GIFT_CARD: 'GIFT_CARD',
};

export const END_OF_DATE_REPORT_PAYMENT_COLORS = {
  MASTERPASS: '#ec2027',
  CASH_ON_DELIVERY: '#ccc146',
  CASH_ON_DELIVERY_BY_CREDIT_CARD: '#0751a0',
  PAYMENT_BY_VOUCHERS: '#824693',
  PAYMENT_BY_GIFT_CARD: '#e82a79',
  OTHER_PAYMENTS: '#547e3f',
  GIFT_CARD: '#e82a79',
  WALLET: '#824693',
  TRENDYOL: '#fe7204',
  TRENDYOLHEMEN: '#cc955f',

  TOTAL_CASH_FEE: '#ccc146',
  TOTAL_CREDIT_CARD_FEE: '#0751a0',
  TOTAL_MASTERPASS_FEE: '#ec2027',
  TOTAL_WALLET_FEE: '#824693',
  TOTAL_GIFTCARD_FEE: '#e82a79',
  TOTAL_OTHER_FEE: '#547e3f',
  TOTAL_FEE: '#000000',
};
export const COURIER_STATUS = {
  ON_HOLD: 'ON_HOLD',
  IN_DISTRIBUTION: 'IN_DISTRIBUTION',
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE',
};

export const OVER_OR_UNDER_COLLECTION_PERCENTAGE = {
  5: '5',
  10: '10',
  15: '15',
  20: '20',
  25: '25',
  30: '30',
  35: '35',
  40: '40',
  45: '45',
  50: '50',
};

export const OVER_OR_UNDER_TOTAL = {
  OPEN: true,
  CLOSE: false,
};

export const ZONE_STATUS = {
  ACTIVE: 'ACTIVE',
  PASSIVE: 'PASSIVE',
};

export const ZONE_APPROVAL_STATUS = {
  APPROVED: 'APPROVED',
  WAITING_FOR_APPROVAL: 'WAITING_FOR_APPROVAL',
  NOT_APPROVED: 'NOT_APPROVED',
  NEW: 'NEW',
  CANCELLED: 'CANCELLED',
  HAS_NEW_VERSION_FOR_APPROVAL: 'HAS_NEW_VERSION_FOR_APPROVAL',
};

export const ZONE_TYPE = {
  ORDER_ZONE: 'ORDER_ZONE',
  STORE_ZONE: 'STORE_ZONE',
  RED_ZONE: 'RED_ZONE',
};

export const SLOTS = [
  '08:00-09:00',
  '09:00-10:00',
  '10:00-11:00',
  '11:00-12:00',
  '12:00-13:00',
  '13:00-14:00',
  '14:00-15:00',
  '15:00-16:00',
  '16:00-17:00',
  '17:00-18:00',
  '18:00-19:00',
  '19:00-20:00',
  '20:00-21:00',
  '21:00-22:00',
  '22:00-23:00',
];

export const AUTH_ROLE_CAN_APPROVE = {
  CENTRAL_OPERATIONS_EXECUTIVE: 'CENTRAL_OPERATIONS_EXECUTIVE',
};

export const NEIGHBORHOOD_STYLE = {
  fillOpacity: 0,
  strokeWeight: 1,
  strokeColor: '#FB0A0A',
  zIndex: 0,
  clickable: false,
};
export const DISTRICT_STYLE = {
  fillOpacity: 0,
  strokeWeight: 1,
  strokeColor: '#05519F',
  zIndex: 1,
  clickable: false,
};
export const CITY_STYLE = {
  fillOpacity: 0,
  strokeWeight: 1.5,
  strokeColor: '#808080',
  zIndex: 2,
  clickable: false,
};

export const DISABLED_INPUT = {
  backgroundColor: '#fff',
  color: '#000',
  cursor: 'default',
  opacity: 1,
};

export const ZONE_COLORS = [
  { id: 1, color: '#FF634E' },
  { id: 2, color: '#FFC046' },
  { id: 3, color: '#D5F74E' },
  { id: 4, color: '#89E27A' },
  { id: 5, color: '#71DAE8' },
  { id: 6, color: '#6E97D3' },
  { id: 7, color: '#AF71D5' },
];

export const COURIERS_AWAITING_COLORS = [
  { id: 1, color: '#71DAE8' },
  { id: 2, color: '#D5F74E' },
  { id: 3, color: '#FFC046' },
  { id: 4, color: '#6E97D3' },
  { id: 5, color: '#FF634E' },
  { id: 6, color: '#89E27A' },
  { id: 7, color: '#AF71D5' },
];

export const ERROR_CODES = {
  LMI_1019: 'LMI-1019',
  GRDR_1005: 'GRDR-1005',
  GRDR_1006: 'GRDR-1006',
  GRDR_1007: 'GRDR-1007',
  GRDR_1008: 'GRDR-1008',
  GRDR_1009: 'GRDR-1009',
  SLOT_TEMPLATE_RELATED_WITH_ZONE_EXCEPTION:
    'SLOT_TEMPLATE_RELATED_WITH_ZONE_EXCEPTION',
  PROGRESS_PAYMENT_TEMPLATE_MAIN_DELETE_EXCEPTION:
    'PROGRESS_PAYMENT_TEMPLATE_MAIN_DELETE_EXCEPTION',
  PROGRESS_PAYMENT_TEMPLATE_MAIN_ALREADY_EXISTS_EXCEPTION:
    'PROGRESS_PAYMENT_TEMPLATE_MAIN_ALREADY_EXISTS_EXCEPTION',
  ORDER_TRANSFER_EXCEPTION: 'ORDER_TRANSFER_EXCEPTION',
};
export const MAP_DEFAULT_VALUES = {
  ZOOM: 10,
  LAT: 41.065233,
  LNG: 28.914577,
  MAX_ZOOM: 15,
};

export const DateFormat = {
  DayDateFormat: 'DD/MM/YYYY',
  YearDateFormat: 'YYYY-MM-DD',
  WithHourDateFormat: 'YYYY-MM-DD HH:mm',
};

export const STORE_STATUS = {
  PASSIVE: 'PASSIVE',
};

export const CSV_EXPORT_COLUMNS = [
  'zoneCode',
  'zoneName',
  'areaKm',
  'storeCode',
  'storeName',
  'cityName',
  'districtName',
  'zoneType',
  'zoneStatus',
  'isOvenAvailable',
  'note',
  'isMainZone',
  'priority',
  'deliveryModel',
];

export const CSV_ROUTING_EXPORT_COLUMNS = [
  'taskId',
  'taskStartTime',
  'slot',
  'solverStatus',
  'taskStartTime',
  'zone',
  'taskStartTime',
  'taskEndTime',
  'time',
  'routeCount',
  'estimatedRouteLength',
];

export const MAX_CHARACTER_LENGTH = 80;

export const COURIER_CHANGE_STATES = [
  'NEW_ORDER',
  'COLLECTING',
  'SEMI_COLLECTED',
  'COLLECTED',
  'IN_TRANSIT',
  'AT_CUSTOMER_ADDRESS',
];

export const MAP_LIBRARIES = ['drawing', 'places'];

export const CITY_DISTRICT_NEIGHBORHOOD = {
  CITY: 'city',
  DISTRICT: 'district',
  NEIGHBORHOOD: 'neighborhood',
};

export const PAYMENT_TYPE = {
  BULK_INVOICE: 'Toplu fatura kesimi',
  INDIVIDUAL_INVOICE: 'Bireysel fatura kesimi',
};

export const DAYS = {
  MONDAY: 'Pazartesi',
  TUESDAY: 'Salı',
  WEDNESDAY: 'Çarşamba',
  THURSDAY: 'Perşembe',
  FRIDAY: 'Cuma',
  SATURDAY: 'Cumartesi',
  SUNDAY: 'Pazar',
};

export const TASK_RULE_TYPES = {
  ORDERING: 'Sipariş',
  ORDER_RECEIVING: 'Teslimat',
};

export const TASK_FREQUENCY = {
  WEEKLY: 'Haftalık',
  MONTHLY: 'Aylık',
  YEARLY: 'Yıllık',
};

export const MONTHS_EN = {
  JANUARY: 'Ocak',
  FEBRUARY: 'Şubat',
  MARCH: 'Mart',
  APRIL: 'Nisan',
  MAY: 'Mayıs',
  JUNE: 'Haziran',
  JULY: 'Temmuz',
  AUGUST: 'Ağustos',
  SEPTEMBER: 'Eylül',
  OCTOBER: 'Ekim',
  NOVEMBER: 'Kasım',
  DECEMBER: 'Aralık',
};

export const SLOT_BUTTONS = {
  AUTO_COPY: 'auto',
  MANUEL_ADD: 'plus',
  COPY_DAYS: 'copy',
};
export const EXPORT_LIMIT = 10000;

export const CSV_EXPORT_COLUMNS_DISTANCE_REPORT = [
  'courierName',
  'platform',
  'orderNo',
  'orderDateOfDelivery',
  'storeCode',
  'storeName',
  'storeLatitude',
  'storeLongitude',
  'addressLatitude',
  'addressLongitude',
  'courierType',
  'status',
  'estimatedDistance',
  'airDistance',
];

export const CSV_EXPORT_COLUMNS_ORDER_STATUS_REPORT = [
  'orderNumber',
  'platform',
  'orderPlacementDate',
  'region',
  'storeCode',
  'store',
  'customerFullName',
  'customerId',
  'customerPhoneNumber',
  'orderStatus',
  'cancelReturnStatus',
  'cancellationReason',
  'nonDeliveryReason',
  'paymentType',
  'deliveryType',
  'orderDeliveryDate',
  'orderSlot',
  'collectionStartDate',
  'collectionEndDate',
  'collectionTime',
  'courierDeliveryDate',
  'customerDeliveryDate',
  'deliveryTime',
  'totalPrice',
  'refundedPrice',
  'refundAmountForUnavailableProduct',
  'partialRefundAmount',
  'amountFromExtra',
  'customerCollectedAmount',
  'courierCoordinateTimeOfDelivery',
  'coordinatesOfCustomer',
  'collectorFullName',
  'courierFullName',
  'customerType',
];

export const FILE_TEMPLATE_CODE = {
  COURIER_ACTIVE_PASSIVE: 'CourierActivePassive',
  USER_ACTIVE_PASSIVE: 'UserActivePassive',
  COURIER_CREATE_OR_UPDATE: 'CourierCreateOrUpdate',
  COLLECTOR_CREATE_OR_UPDATE: 'CollectorCreateOrUpdate',
  ZONE_SLOT_TEMPLATE: 'ZoneSlotTemplate',
  STORE_CATEGORY_RANKING_CREATE_OR_UPDATE: 'StoreCategoryRankingCreateOrUpdate',
  STORE_UPDATE: 'StoreUpdate',
  SLOT_CAPACITY_UPDATE: 'SlotCapacityUpdate',
  BULK_NOTIFICATION_TEMPLATE: 'BulkNotificationTemplate',
  BULK_ZONE_UPDATE: 'BulkZoneUpdate',
};

export const DAY_OPTIONS = [
  { key: 1, label: 'MONDAY', value: 'MONDAY' },
  { key: 2, label: 'TUESDAY', value: 'TUESDAY' },
  { key: 3, label: 'WEDNESDAY', value: 'WEDNESDAY' },
  { key: 4, label: 'THURSDAY', value: 'THURSDAY' },
  { key: 5, label: 'FRIDAY', value: 'FRIDAY' },
  { key: 6, label: 'SATURDAY', value: 'SATURDAY' },
  { key: 7, label: 'SUNDAY', value: 'SUNDAY' },
];

export const ECOM_STATUS = {
  OPEN: 'OPEN',
  CLOSED: 'CLOSED',
  WAITING: 'WAITING',
  TEMPORARY_CLOSED: 'TEMPORARY_CLOSED',
};

export const SOLVER_STATUS = {
  CALCULATING: 'CALCULATING',
  WAITING_FOR_APPROVAL: 'WAITING_FOR_APPROVAL',
  APPROVED: 'APPROVED',
  DISTRIBUTION_STARTED: 'DISTRIBUTION_STARTED',
  DISTRIBUTION_COMPLETED: 'DISTRIBUTION_COMPLETED',
  ERROR: 'ERROR',
  CANCELLED: 'CANCELLED',
};

export const STORE_DAILY_STATUSES = ['OPEN', 'CLOSED', 'TEMPORARILY_CLOSED'];

export const SHIPMENT_TYPES = [
  'FAST',
  'CARGO',
  'SLOT',
  'IN_STORE',
  'NO_SHIPMENT',
];

export const COLLECTION_TYPE = ['BAG', 'BOX'];

export const SELECT_DISTRIBUTOR = {
  DOUBLE_DISTRIBUTOR: 'DOUBLE_DISTRIBUTOR',
  SHARE_DISTRIBUTOR: 'SHARE_DISTRIBUTOR',
};

export const ORDERS_TYPES = {
  SLOT: 'SLOT',
  RETURN: 'RETURN',
};

export const INVOICE_TYPE = {
  ELECTRONIC: 'ELECTRONIC',
  HARD: 'HARD',
};

export const TARGET_GROUP = {
  CRAFTMAN: 'CRAFTMAN',
  REGULAR: 'REGULAR',
};

export const PROGRESS_PAYMENT_PERIOD = {
  MONTHLY: 'MONTHLY',
  ANNUAL: 'ANNUAL',
};

export const CHARGING_METHOD = {
  ORDER_COUNT: 'ORDER_COUNT',
  WORKING_HOURS: 'WORKING_HOURS',
};

export const RULE_TYPES = {
  WORKING_HOURS: 'WORKING_HOURS',
  CUSTOMER_SATISFACTION: 'CUSTOMER_SATISFACTION',
  MIN_WORK_HOUR: 'MIN_WORK_HOUR',
  PAY_DAY_APPLICATION_ACTIVITY: 'PAY_DAY_APPLICATION_ACTIVITY',
};

export const CALCULATION_METHODS = {
  COURIER_LOCATION: 'COURIER_LOCATION',
  APPLICATION_ACCESS: 'APPLICATION_ACCESS',
};

export const UNIT_TYPES = {
  HOURS: 'HOURS',
  DAYS: 'DAYS',
};

// Don't touch and change order EXTRA_ITEM_TYPE because the HakEdiş page depends entirely on this enum.
export const EXTRA_ITEM_TYPE = {
  GRADUAL_INCREASE: 'GRADUAL_INCREASE', // Kademeli Hakediş Artışı Tab
  LONG_DELIVERY_DISTANCE: 'LONG_DELIVERY_DISTANCE', // Uzun Mesafe Tab
  OVER_DESI: 'OVER_DESI', // Fazla Desi Tab
  OVER_WEIGHT: 'OVER_WEIGHT', // Fazla KG Tab (gram)
};
export const CALCULATING_TYPE = {
  SINGLE_ORDER: 'SINGLE_ORDER',
  SINGLE_PRODUCT: 'SINGLE_PRODUCT',
  ALL_ORDERS: 'ALL_ORDERS',
};

export const ORDER_COLLECTION_TYPE = {
  BAG: 'BAG',
  BOX: 'BOX',
};
export const TARGET_AREA = {
  CITY: 'CITY',
  REGION: 'REGION',
};

export const PROGRESS_PAYMENT_STATUS = {
  DRAFT: 'DRAFT',
  WAITING_FOR_INVOICE: 'WAITING_FOR_INVOICE',
  WAITING_FOR_APPROVAL: 'WAITING_FOR_APPROVAL',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
};

export const PROGRESS_PAYMENT_DETAIL_TYPES = {
  GRADUAL_INCREASE: 'GRADUAL_INCREASE',
  LONG_DELIVERY_DISTANCE: 'LONG_DELIVERY_DISTANCE',
  OVER_DESI: 'OVER_DESI',
  CHARGING: 'CHARGING',
  SPECIAL_PRODUCT: 'SPECIAL_PRODUCT',
  OVER_WEIGHT: 'OVER_WEIGHT',
};

export const ROUTE_NAMES = {
  STORE_UPDATE: 'storeUpdate',
};

export const SLOT_MONITORING_DAYS = {
  TODAY: 'TODAY',
  TOMORROW: 'TOMORROW',
};

export const CONFIG_KEYS = {
  REACT_APP_AUTH_UI_ADDRESS: 'REACT_APP_AUTH_UI_ADDRESS',
  REACT_APP_ENV_INFO: 'REACT_APP_ENV_INFO',
  REACT_APP_GOOGLE_MAP_API_KEY: 'REACT_APP_GOOGLE_MAP_API_KEY',
};

export const ENVIRONMENT = {
  LOCAL: 'LOCAL',
  DEV: 'QA',
  TEST: 'TEST',
  PRODUCTION: 'PRODUCTION',
};
export const ADVANCE_PRICE_TYPE = {
  FIXED_PRICE: 'FIXED_PRICE',
  PROGRESS_PAYMENT_RELATED: 'PROGRESS_PAYMENT_RELATED',
};

export const LIVE_SCREEN_EXECUTIVE = {
  BRANCH_MANAGER: 'BRANCH_MANAGER',
};

export const MONTHS = [
  'Ocak',
  'Şubat',
  'Mart',
  'Nisan',
  'Mayıs',
  'Haziran',
  'Temmuz',
  'Ağustos',
  'Eylül',
  'Ekim',
  'Kasım',
  'Aralık',
];

export const CHANNEL = {
  TRANSFORMATION: 'TRANSFORMATION',
};

export const ORDERS_CHANNEL = {
  ISTEGELSIN: 'ISTEGELSIN',
  SOK_POSITIVE: 'POSITIVE',
  SOK_ECOM: 'TRANSFORMATION',
};

export const REPORT_TYPES = {
  DELAYED_AND_WAITING_FOR_COLLECTION: 'DELAYED_AND_WAITING_FOR_COLLECTION',
  DELAYED_ON_COURIER: 'DELAYED_ON_COURIER',
  DELAYED_DELIVERY_AND_WAITING_FOR_DELIVERY:
    'DELAYED_DELIVERY_AND_WAITING_FOR_DELIVERY',
  DELAYED_BY_WAITING_FOR_COURIER: 'DELAYED_BY_WAITING_FOR_COURIER',
  DELAYED_COLLECTION_ON_TIME: 'DELAYED_COLLECTION_ON_TIME',
  DELAYED_DELIVERY_FROM_STORE: 'DELAYED_DELIVERY_FROM_STORE',
  DELAYED_APPROVAL: 'DELAYED_APPROVAL',
};

export const NOTIFICATION_METHODS = {
  EMAIL: 'EMAIL',
  SMS: 'SMS',
  ANNOUNCEMENT: 'ANNOUNCEMENT',
  PUSH: 'PUSH',
};

export const NOTIFICATION_TARGET_USERS = {
  COLLECTOR: 'collector',
  COURIER: 'courier',
  EXCEL_UPLOAD: 'EXCEL_UPLOAD',
};

export const TARGET_DATE = {
  INSTANT: 'INSTANT',
  PLANNED: 'PLANNED',
};

export const PERFORMANCE_MASTER_METRIC = {
  NON_RETURNED_AND_ON_TIME_COMPLETE_COLLECTION:
    'NON_RETURNED_AND_ON_TIME_COMPLETE_COLLECTION',
  OTIF: 'OTIF',
  CANCELLATION_AND_RETURN: 'CANCELLATION_AND_RETURN',
  COMPLAINT: 'COMPLAINT',
};

export const BONUS_PENALTY_TYPE = {
  KPI: 'KPI',
  CUSTOMER_SURVEY: 'CUSTOMER_SURVEY',
};

export const BONUS_PENALTY_IMPACT = {
  P: 'P',
  N: 'N',
};

export const PROGRESS_PAYMENT_TYPE = {
  STORE_PROGRESS_PAYMENT: 'STORE_PROGRESS_PAYMENT',
  PROGRESS_PAYMENT: 'PROGRESS_PAYMENT',
};

export const INVOICE_APPROVAL_PROGRESS_PAYMENT_TYPE = {
  ADVANCE_PAYMENT: 'ADVANCE_PAYMENT',
  PROGRESS_PAYMENT: 'PROGRESS_PAYMENT',
};

export const EFFECT_TYPE = {
  rulePositive: 'POSITIVE',
  ruleNegative: 'NEGATIVE',
};

export const RULES_OPERATOR = {
  EQUAL: '=',
  LESS_THAN: '<',
  GREATER_THAN: '>',
};

export const COURIER_SOURCE = {
  Bringo: 'BRINGO',
  CepteŞOK: 'CEPTESOK',
};

export const ITEM_TYPE_ORDERS = {
  regularOrder: 'SLOT',
  changeOrder: 'CHANGE',
  returnPickup: 'RETURN_PICKUP',
};

export const COURIERS_AWAITING_APPROVAL_STATUS = {
  DRAFT: 'DRAFT',
  WAITING_APPROVAL: 'WAITING_APPROVAL',
  WAITING_FINANCE_APPROVAL: 'WAITING_FINANCE_APPROVAL',
  DECLINED: 'DECLINED',
  APPROVED: 'APPROVED',
  LEFT: 'LEFT',
};
